import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  MenuItem,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { Box } from "@mui/system";
import { IoCloseOutline } from "react-icons/io5";
import moment from "moment";
import Constants from "../data/Constants";
import { Link } from "react-router-dom";
import Seperator from "components/Seperator";
import {
  cancelCounsellingSession,
  getMentorSlots,
  updateCounsellingSession,
} from "services/mentor.service";
import Utils from "utils";
import { useEffect } from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CounsellingDetailsDialog(props) {
  const { open, counselling, onClose } = props;

  const [slots, setSlots] = useState([]);

  const [slot, setSlot] = useState("");

  useEffect(() => {
    if (counselling) {
      setSlot(counselling.slot._id);
    }
  }, [counselling]);

  useEffect(() => {
    async function api() {
      try {
        setStatus({
          loading: true,
          error: false,
        });

        const res = await getMentorSlots(counselling.mentor._id);
        setSlots(res);
        setStatus({
          loading: false,
          error: false,
        });
      } catch (error) {
        // error
        setStatus({
          loading: false,
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }

    if (counselling) {
      api();
    }
  }, [counselling]);

  const [status, setStatus] = useState({
    loading: false,
    error: false,
    success: false,
  });

  const handleCancel = async () => {
    try {
      setStatus({
        loading: true,
        error: false,
      });

      const data = await cancelCounsellingSession(counselling._id);

      setStatus({
        loading: false,
        error: false,
        success: true,
        message: "Counselling Session Cancelled Successfully",
      });

      // onCreate(values);

      onClose();
    } catch (error) {
      // error
      setStatus({
        loading: false,
        error: true,
        message: Utils.CustomErrorMessage(error),
      });

      onClose();
    }
  };

  const handleRescheduleCounsellingSession = async () => {
    try {
      setStatus({
        loading: true,
        error: false,
      });

      const data = await updateCounsellingSession(counselling._id, { slot });

      setStatus({
        loading: false,
        error: false,
        success: true,
        message: "Counselling Session Cancelled Successfully",
      });
    } catch (error) {
      // error
      setStatus({
        loading: false,
        error: true,
        message: Utils.CustomErrorMessage(error),
      });
    }
  };

  return counselling ? (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1} className="font-extrabold text-lg">
            Counselling Actions
          </Box>
          <Box>
            <IconButton onClick={onClose}>
              <IoCloseOutline />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <h1 className="text-small font-bold py-2">Reschedule Session</h1>

        <TextField
          label="Slots"
          variant="filled"
          size="small"
          name="type"
          value={slot}
          onChange={(e) => {
            setSlot(e.target.value);
          }}
          required
          fullWidth
          select
        >
          {slots.map((s, index) => {
            return (
              <MenuItem key={index} value={s._id}>
                {moment(s.time).format(Constants.DATE_TIME_FORMAT) + " "}(
                {s.duration + " mins"})
              </MenuItem>
            );
          })}
        </TextField>

        <Button
          variant="contained"
          fullWidth
          style={{ marginTop: "20px" }}
          onClick={handleRescheduleCounsellingSession}
        >
          Reschedule Session
        </Button>

        <div
          className={"text-" + (status.error ? "red" : "green") + "-800 py-4"}
        >
          {status.message}
        </div>

        {}

        <Seperator />
        <div className="flex justify-center">
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
            fullWidth
          >
            Cancel Session
          </Button>
        </div>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose}>
          Ok
        </Button>
      </DialogActions>
      {status.loading ? (
        <Box>
          <LinearProgress />
        </Box>
      ) : (
        ""
      )}
    </Dialog>
  ) : (
    ""
  );
}

export default CounsellingDetailsDialog;
